export const QUIZ_QUESTION_LIST_LOADING = "QUIZ_QUESTION_LIST_LOADING";
export const QUIZ_QUESTION_LIST_SUCCESS = "QUIZ_QUESTION_LIST_SUCCESS";
export const QUIZ_QUESTION_LIST_ERROR = "QUIZ_QUESTION_LIST_ERROR";

export const QUIZ_QUESTION_VIEW_LOADING = "QUIZ_QUESTION_VIEW_LOADING";
export const QUIZ_QUESTION_VIEW_SUCCESS = "QUIZ_QUESTION_VIEW_SUCCESS";
export const QUIZ_QUESTION_VIEW_ERROR = "QUIZ_QUESTION_VIEW_ERROR";
